export default "__VITE_ASSET__DFrvOGqa__"